<div class="fx-modal">
  <h1 mat-dialog-title class="title">{{ 'fx_deal_cancellation.title' | translate }}
    <button mat-icon-button (click)="close()" class="close-icon">
      <mat-icon>close</mat-icon>
    </button>
  </h1>

  <div class="dialog-title1">
    <div>{{ 'fx_deal_cancellation.offset' | translate }} :</div>
    <div class="centered-offset">{{ offset }} {{ currency }}</div>
  </div>
  <div class="dialog-title2">
    <div>{{ 'fx_deal_cancellation.expiresIn' | translate }} :</div>
    <div class="centered-offset"><span class="interval">{{ expireInterval }} </span> {{ 'fx_deal_cancellation.expiresIn.seconds'| translate }}</div>
  </div>
  <div class="dialog-content">
    <div>{{ 'fx_deal_cancellation.reason' | translate }}</div>
    <mat-form-field appearance="outline" class="dialog-notes-fields">
      <textarea matInput [(ngModel)]="reason" [placeholder]="'Notes'"></textarea>
    </mat-form-field>
  </div>
  <div class="status-container">
    <div class="status"
         [ngClass]="{'info': statusType === StatusType.INFO,
        'error': statusType === StatusType.ERROR}">
      <div class="text-status">
        <span class="message-icon" *ngIf="statusType === StatusType.INFO"><app-fn-ui-icon icon="information_outline"
                                                                                          size="20px"></app-fn-ui-icon></span>
        <span class="message-icon" *ngIf="statusType === StatusType.ERROR"><app-fn-ui-icon icon="alert_circle_outline"
                                                                                           size="20px"></app-fn-ui-icon></span>
        <span class="message">{{ status | translate}}</span>
      </div>
      <div class="loader">
        <div class="wrapper" libLoader [loaderVisible]="showLoader" [loaderComponent]="spinnerComponent"></div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-flat-button (click)="close()">{{ 'fx_deal_cancellation.buttons.close' | translate }}</button>
    <button mat-flat-button color="primary" [disabled]="cancelDisabled"
            (click)="sendCancellationRequest()">{{ 'fx_deal_cancellation.buttons.cancelFXDeal' | translate }}
    </button>
  </div>
</div>
